import { Box, Paper, Stack, Typography } from '@mui/material';
import Contact_image from 'assets/images/contact.svg';
import { useIsMobile } from 'hooks';
import React from 'react';

export const Contact = () => {
  const { isMobile } = useIsMobile();

  return (
    <Paper>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ p: 5, borderBottom: 1, borderColor: 'divider' }}
      >
        <Typography variant="h2">Kontakt</Typography>
      </Stack>
      <Stack direction="column" alignItems="center" p={5}>
        <Stack direction="column" mb={10} alignItems="center">
          <Box component="img" alt="Contact page img" src={Contact_image} />
          <Typography variant="h3" py={4} lineHeight={'28px'}>
            Wir helfen dir gerne weiter
          </Typography>
          <Typography
            variant="h3"
            lineHeight={'28px'}
            color="primary.main"
            component="a"
            sx={{ textDecoration: 'none' }}
            href="mailto:hello@alloyads.ai"
          >
            hello@alloyads.ai
          </Typography>
          <Typography
            variant="h3"
            lineHeight={'28px'}
            color="primary.main"
            component="a"
            sx={{ textDecoration: 'none' }}
            href={isMobile ? 'tel:+41442596558' : '#'}
          >
            +41 44 259 65 58
          </Typography>
        </Stack>
        <Stack
          direction={isMobile ? 'column' : 'row'}
          justifyContent="space-around"
          width="100%"
          borderRadius={3}
          py={5}
          sx={{ backgroundColor: 'grey.50' }}
        >
          <Stack direction="column" mb={isMobile ? 10 : 0}>
            <Typography variant="h3" mb={4} align="center" lineHeight={'28px'}>
              Erreichbarkeit
            </Typography>
            <Typography align="center">
              Montag bis Freitag
              <br />
              08:00 - 12:00 Uhr
              <br />
              13:00 - 17:00 Uhr
            </Typography>
          </Stack>
          <Stack direction="column">
            <Typography variant="h3" mb={4} align="center" lineHeight={'28px'}>
              Adresse
            </Typography>
            <Typography align="center">
              Ringier AG - Global Tech&Data Unit
              <br />
              Dufourstrasse 23
              <br />
              CH-8008 Zürich
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  );
};
